import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { createHost } from "../../store/host/host.action";

import { CLOSE_HOST_DIALOG } from "../../store/host/host.type";
// import { createHost, editHost } from "../../store/host/host.action";
import ReactDropzone from "react-dropzone";
import $ from "jquery";
import noImage from "../../assets/img/female.png";
import { getLanguage } from "../../store/language/language.action";

const HostDialogue = (props) => {
  // const { dialog } = useSelector((state) => state.host);
  const { dialog, dialogMode } = useSelector((state) => state.host);

  const dispatch = useDispatch();
const languages = useSelector((state) => state.language?.languages || []);

// Fetch languages once on component mount
useEffect(() => {
  dispatch(getLanguage());
}, [dispatch]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [country, setCountry] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [bio, setBio] = useState("");

  const [videoType, setVideoType] = useState("1");
  const [imageType, setImageType] = useState("1");
const [coin, setCoin] = useState("");
  const [image, setImage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [showImage, setShowImage] = useState("");

  const [video, setVideo] = useState("");
  const [videoPath, setVideoPath] = useState("");
  const [showVideo, setShowVideo] = useState("");

  const [album, setAlbum] = useState([]);
const [error, setError] = useState({});
const [language, setLanguage] = useState([]);
  // useEffect(() => {
  //   if (dialogData) {
  //     setName(dialogData.name);
  //     setEmail(dialogData.email);
  //     setAge(dialogData.age);
  //     setGender(dialogData.gender);
  //     setCountry(dialogData.country);
  //     setBio(dialogData.bio);
  //     setVideoType(dialogData.videoType?.toString());
  //     setImageType(dialogData.imageType?.toString());
  //     setAlbum(dialogData.album || []);

  //     dialogData.videoType === 1
  //       ? setVideoPath(dialogData.video)
  //       : setShowVideo(dialogData.video);

  //     dialogData.imageType === 1
  //       ? setImagePath(dialogData.image)
  //       : setShowImage(dialogData.image);
  //   }
  // }, [dialog]);
  useEffect(() => {
  if (!dialog) {
    // dialog close hone pe reset
    setName("");
    setEmail("");
    setBio("");
    setDob("");
    setImagePath("");
    setImage([]);
    setCountry("");
    setVideoType("1"); // default value
    setImageType("1"); // default value
    setError({});
    setAlbum([]);
    setVideoPath("");
    setVideo([]);
    setGender("");
    setCoin(""); // coin reset
    setLanguage([]); // language reset
    setMobileNo("");
  }
}, [dialog]);

  useEffect(() => {
    window.onbeforeunload = handleClose();
  }, []);

  const handleClose = () => {
    dispatch({ type: CLOSE_HOST_DIALOG });
  };

  const isValidURL = (url) => {
    if (typeof url !== "string") {
      return false; // Make sure url is a string
    }

    const urlRegex = /^(ftp|http|https):\/[^ "]+$/;
    return urlRegex.test(url) || url?.startsWith("blob:");
  };

  const handelSubmit = () => {
    if (
      !name ||
      !bio ||
      !email ||
      !dob ||
      !country ||
      !gender ||
      !videoType ||
      !coin ||
      (imageType === 1 && !imagePath) ||
      (imageType === 1 && !isValidURL(imagePath)) ||
      (videoType === 1 && !videoPath) ||
      (videoType === 1 && !isValidURL(videoPath))
    ) {
      const error = {};
      if (!name) error.name = "Name is required";
      if (!bio) error.bio = "Bio is Required";
      if (!email) error.email = "Email is required";
      if (!dob) error.dob = "DOB is required";
      if (!gender) error.gender = "Gender is required";
      if (!coin) error.coin = "Coin is required";
      if (!language || language.length === 0) error.language = "Language is required";
      if (mobileNo && !/^\d{10}$/.test(mobileNo)) error.mobileNo = "Mobile Number must be ten digit";

      
      if (!videoType) error.videoType = "Link Type Is Required";
      if (!imageType) error.imageType = "Image Type Is Required";
      if (!country) error.country = "Country is Required";
      if (album.length === 0) error.album = "At least one image is required";

      // Validate based on type
      if (videoType === 1) {
        if (!videoPath) {
          error.video = "Video URL is required";
        } else if (!isValidURL(videoPath)) {
          error.video = "Invalid video URL";
        }
      } else if (videoType === 0) {
        if (!video || video.length === 0) {
          error.video = "Video file is required";
        }
      }

      if (imageType === 1) {
        if (!imagePath) {
          error.image = "Image URL is required";
        } else if (!isValidURL(imagePath)) {
          error.image = "Invalid image URL";
        }
      } else if (imageType === 0) {
        if (!image || image.length === 0) {
          error.image = "Image file is required";
        }
      }
      return setError({ ...error });
    } else {
      
      const formData = new FormData();

      formData.append("name", name);
      formData.append("email", email);
      formData.append("dob", dob);
      formData.append("gender", gender);
      formData.append("coin", coin);
      formData.append("videoType", parseInt(videoType));
      formData.append("language", JSON.stringify(language));
      formData.append("imageType", parseInt(imageType));
      formData.append("mobileNumber", mobileNo);

      formData.append("bio", bio);
      imageType == 1
        ? formData.append("image", imagePath)
        : formData.append("image", image);
      videoType == 1
        ? formData.append("video", videoPath)
        : formData.append("video", video);
      formData.append("country", country);
      for (let i = 0; i < album.length; i++) {
        formData.append("album", album[i]);
      }

      props.createHost(formData);
handleClose();
    }
  };

  const handleKeyPress = (event) => {
    if (event.key == "Enter") {
      handelSubmit();
    }
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
    setShowImage(URL.createObjectURL(e.target.files[0]));
  };

  const handleVideo = (e) => {
    setVideo(e.target.files[0]);
    setVideoPath(URL.createObjectURL(e.target.files[0]));
    setShowVideo(URL.createObjectURL(e.target.files[0]));
  };

  const onPreviewDrop = (files) => {
    setError({ ...error, album: "" });
    files.map((file) =>
      Object.assign(file, { preview: URL.createObjectURL(file) })
    );

    setAlbum(album.concat(files));
  };

  const removeImage = (file) => {
    const newFiles = [...album];
    album.splice(newFiles.indexOf(file), 1);
    if (file.preview) {
      const images = album.filter((ele) => {
        return ele.preview !== file.preview;
      });
      setAlbum(images);
    } else {
      const newFiles = [...album];
      album.splice(newFiles.indexOf(file), 1);
      setAlbum(newFiles);
    }
  };

  // set default image

  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", noImage);
    });
  });
  return (
    <>
      <Dialog
      open={dialog && dialogMode === "add"}
        aria-labelledby="responsive-dialog-title"
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="dialogue_background_color"
        >
          <span className="modal-title font-weight-bold h4">
             Host Create
          </span>
        </DialogTitle>
        <DialogContent className="dialogue_background_color">
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div>
                      <div className="form-group mb-0">
                        <p className="form-label fw-bold mt-3"> Name </p>
                      </div>
                      <input
                        type="text"
                        placeholder="Name"
                        className="form-control"
                        autocomplete="off"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          if (!e.target.value)
                            return setError({
                              ...error,
                              name: "Name Is Required !",
                            });
                          else {
                            return setError({
                              ...error,
                              name: "",
                            });
                          }
                        }}
                        onKeyPress={handleKeyPress}
                      />
                      {error.name && (
                        <div class="pl-1 text-left">
                          <Typography
                            variant="caption"
                            color="error"
                            style={{ fontFamily: "Circular-Loom" }}
                          >
                            {error.name}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div>
                      <div className="form-group mb-0">
                        <p className="form-label fw-bold mt-3"> Email </p>
                      </div>
                      <input
                        type="text"
                        min="0"
                        placeholder="Email"
                        className="form-control pe-1"
                        autocomplete="off"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          if (!e.target.value)
                            return setError({
                              ...error,
                              email: "Email  Is Required !",
                            });
                          else {
                            return setError({
                              ...error,
                              email: "",
                            });
                          }
                        }}
                        onKeyPress={handleKeyPress}
                      />
                      {error.email && (
                        <div class="pl-1 text-left">
                          <Typography
                            variant="caption"
                            color="error"
                            style={{ fontFamily: "Circular-Loom" }}
                          >
                            {error.email}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div>
                      <div>
                        <div className="form-group mb-0">
                          <p className="form-label fw-bold mt-3">DOB</p>
                        </div>
                        <input
                          type="date"
                          placeholder="DOB"
                          value={dob}
                          className="form-control pe-1"
                          autocomplete="off"
                          onChange={(e) => {
                            setDob(e.target.value);
                            if (!e.target.value)
                              return setError({
                                ...error,
                                dob: "DOB Is Required !",
                              });
                            else {
                              return setError({
                                ...error,
                                dob: "",
                              });
                            }
                          }}
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                      {error.dob && (
                        <div class="pl-1 text-left">
                          <Typography
                            variant="caption"
                            color="error"
                            style={{ fontFamily: "Circular-Loom" }}
                          >
                            {error.dob}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 col-12">
                    <div>
                      <div className="form-group mb-0">
                        <p className="form-label fw-bold mt-3"> Country</p>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                          if (!e.target.value) {
                            return setError({
                              ...error,
                              country: "Country Is Required !",
                            });
                          } else {
                            return setError({
                              ...error,
                              country: "",
                            });
                          }
                        }}
                        onKeyPress={handleKeyPress}
                      />
                    </div>
                    {error.country && (
                      <div class="pl-1 text-left">
                        <Typography
                          variant="caption"
                          color="error"
                          style={{ fontFamily: "Circular-Loom" }}
                        >
                          {error.country}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div>
                      <div className="form-group mb-0">
                        <p className="form-label fw-bold mt-3">Mobile No</p>
                      </div>
                      <input
                        type="number"
                        min="0"
                        placeholder="Mobile No"
                        value={mobileNo}
                        className="form-control"
                        autocomplete="off"
                        onChange={(e) => {
                          setMobileNo(
                            (e.target.value = Math.max(0, parseInt(e.target.value))
                              .toString()
                              .slice(0, 10))
                          );
                          if (e.target.value && !/^\d{10}$/.test(e.target.value)) {
                            return setError({
                              ...error,
                              mobileNo: "Mobile Number must be ten digit",
                            });
                          } else {
                            return setError({
                              ...error,
                              mobileNo: "",
                            });
                          }
                        }}
                        onKeyPress={handleKeyPress}
                      />
                    </div>
                    {error.mobileNo && (
                      <div class="pl-1 text-left">
                        <Typography
                          variant="caption"
                          color="error"
                          style={{ fontFamily: "Circular-Loom" }}
                        >
                          {error.mobileNo}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
  {/* Coin */}
  <div className="col-md-6 col-12">
    <div>
      <div className="form-group mb-0">
        <p className="form-label fw-bold mt-3">Coin</p>
      </div>
      <input
        type="number"
        placeholder="Enter Coin"
        className="form-control"
        value={coin}
        min="0"
        onChange={(e) => {
          setCoin(e.target.value);
          if (e.target.value === "") {
            setError({ ...error, coin: "Coin is required" });
          } else {
            setError({ ...error, coin: "" });
          }
        }}
        onKeyPress={handleKeyPress}
      />
      {error.coin && (
        <div className="pl-1 text-left">
          <Typography variant="caption" color="error">
            {error.coin}
          </Typography>
        </div>
      )}
    </div>
  </div>

  {/* Language */}
  <div className="col-md-6 col-12">
    <div>
      <div className="form-group mb-0">
        <p className="form-label fw-bold mt-3">Language</p>
      </div>
      <Select
        className="form-control"
        multiple
        value={language}
        renderValue={(selected) =>
          languages
            .filter((lang) => selected.includes(lang._id))
            .map((lang) => lang.name)
            .join(", ")
        }
        onChange={(e) => {
          const selectedLanguages = e.target.value;
          setLanguage(selectedLanguages);
          if (selectedLanguages.length > 0) {
            setError({ ...error, language: "" });
          } else {
            setError({ ...error, language: "Language is required" });
          }
        }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang._id} value={lang._id}>
            {lang.name}
          </MenuItem>
        ))}
      </Select>

      {error.language && (
        <div className="pl-1 text-left">
          <Typography variant="caption" color="error">
            {error.language}
          </Typography>
        </div>
      )}
    </div>
  </div>
</div>

                <div className="row">
                  <div className="col-md-6 col-12">
                    <div>
                      <div>
                        <div className="form-group mb-0">
                          <p className="form-label fw-bold mt-3"> Bio</p>
                        </div>
                        <input
                          type="text"
                          placeholder="Bio"
                          value={bio}
                          className="form-control "
                          autocomplete="off"
                          onChange={(e) => {
                            setBio(e.target.value);
                            if (!e.target.value)
                              return setError({
                                ...error,
                                bio: "Bio Is Required !",
                              });
                            else {
                              return setError({
                                ...error,
                                bio: "",
                              });
                            }
                          }}
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                      {error.bio && (
                        <div class="pl-1 text-left">
                          <Typography
                            variant="caption"
                            color="error"
                            style={{ fontFamily: "Circular-Loom" }}
                          >
                            {error.bio}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <p className="form-label fw-bold mt-3 "> Gender</p>
                    <FormControl className="mb-0">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={gender}
                        onChange={(e) => {
                          setGender(e.target.value);
                          if (!e.target.value)
                            return setError({
                              ...error,
                              gender: "Gender Is Required !",
                            });
                          else {
                            return setError({
                              ...error,
                              gender: "",
                            });
                          }
                        }}
                      >
                        <FormControlLabel
                          value="Male"
                          control={<Radio />}
                          label="Male"
                        />
                        <FormControlLabel
                          value="Female"
                          control={<Radio />}
                          label="Female"
                        />
                        <FormControlLabel
                          value="Other"
                          control={<Radio />}
                          label="Other"
                        />
                      </RadioGroup>
                    </FormControl>
                    {error.gender && (
                      <div class="pl-1 text-left">
                        <Typography
                          variant="caption"
                          color="error"
                          style={{ fontFamily: "Circular-Loom" }}
                        >
                          {error.gender}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-12">
                    <p className="form-label fw-bold mt-3 ">Video Type</p>
                    <FormControl className="mb-0">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={videoType}
                        onChange={(e) => {
                          setVideoType(e.target.value);
                          if (!e.target.value)
                            return setError({
                              ...error,
                              videoType: "LinkType Is Required !",
                            });
                          else {
                            return setError({
                              ...error,
                              videoType: "",
                            });
                          }
                        }}
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Link"
                          checked={videoType == 1 ? true : false}
                        />
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="File"
                          checked={videoType == 0 ? true : false}
                        />
                      </RadioGroup>
                    </FormControl>
                    {error.videoType && (
                      <div class="pl-1 text-left">
                        <Typography
                          variant="caption"
                          color="error"
                          style={{ fontFamily: "Circular-Loom" }}
                        >
                          {error.videoType}
                        </Typography>
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 col-12">
                    <p className="form-label fw-bold mt-3 ">Image Type</p>
                    <FormControl className="mb-0">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={imageType}
                        onChange={(e) => {
                          setImageType(e.target.value);
                          if (!e.target.value)
                            return setError({
                              ...error,
                              imageType: "Image Type Is Required !",
                            });
                          else {
                            return setError({
                              ...error,
                              imageType: "",
                            });
                          }
                        }}
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Link"
                          checked={imageType == 1 ? true : false}
                        />
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="File"
                          checked={imageType == 0 ? true : false}
                        />
                      </RadioGroup>
                    </FormControl>
                    {error.imageType && (
                      <div class="pl-1 text-left">
                        <Typography
                          variant="caption"
                          color="error"
                          style={{ fontFamily: "Circular-Loom" }}
                        >
                          {error.imageType}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  {videoType == 0 ? (
                    <div className="col-md-6 col-12 my-2">
                      <div>
                        <div className="form-group mb-0">
                          <p className="form-label fw-bold mt-3">Host Video</p>
                        </div>
                        <input
                          type="file"
                          accept="video/mp4,video/x-m4v,video/*"
                          className="form-control "
                          autocomplete="off"
                          onChange={(e) => handleVideo(e)}
                          onKeyPress={handleKeyPress}
                        />
                        {showVideo && (
                          <video
                            autoPlay
                            controls={true}
                            src={showVideo}
                            alt="hostImage"
                            draggable="false"
                            className="p-3 "
                            width={100}
                          />
                        )}
                        {error.video && (
                          <div class="pl-1 text-left">
                            <Typography
                              variant="caption"
                              color="error"
                              style={{ fontFamily: "Circular-Loom" }}
                            >
                              {error.video}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-6 col-12 my-2">
                      <div>
                        <div className="form-group mb-0">
                          <p className="form-label fw-bold mt-3"> Video Link</p>
                        </div>
                        <input
                          type="text"
                          placeholder="Video URL"
                          value={videoPath}
                          className="form-control "
                          autocomplete="off"
                          onChange={(e) => {
                            setVideoPath(e.target.value);
                            if (!e.target.value)
                              return setError({
                                ...error,
                                video: "videoPath Is Required !",
                              });
                            else {
                              return setError({
                                ...error,
                                video: "",
                              });
                            }
                          }}
                          onKeyPress={handleKeyPress}
                        />
                        {videoPath && (
                          <video
                            src={videoPath}
                            alt="hostImage"
                            draggable="false"
                            className="p-3 dialogueImageVideoShow"
                            width={100}
                          />
                        )}

                        {error.video && (
                          <div class="pl-1 text-left">
                            <Typography
                              variant="caption"
                              color="error"
                              style={{ fontFamily: "Circular-Loom" }}
                            >
                              {error.video}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {imageType == 0 ? (
                    <div className="col-md-6 col-12 my-2">
                      <div>
                        <div className="form-group mb-0">
                          <p className="form-label fw-bold mt-3">Host Image</p>
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control "
                          autocomplete="off"
                          onChange={(e) => handleImage(e)}
                          onKeyPress={handleKeyPress}
                        />
                        {showImage && (
                          <img
                            src={showImage}
                            alt="hostImage"
                            draggable="false"
                            className="p-3 "
                            width={100}
                          />
                        )}
                        {error.image && (
                          <div class="pl-1 text-left">
                            <Typography
                              variant="caption"
                              color="error"
                              style={{ fontFamily: "Circular-Loom" }}
                            >
                              {error.image}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-6 col-12 my-2">
                      <div>
                        <div className="form-group mb-0">
                          <p className="form-label fw-bold mt-3"> Image Link</p>
                        </div>
                        <input
                          type="text"
                          placeholder="Image URl"
                          value={imagePath}
                          className="form-control "
                          autocomplete="off"
                          onChange={(e) => {
                            setImagePath(e.target.value);
                            if (!e.target.value)
                              return setError({
                                ...error,
                                image: "imagePath Is Required !",
                              });
                            else {
                              return setError({
                                ...error,
                                image: "",
                              });
                            }
                          }}
                          onKeyPress={handleKeyPress}
                        />
                        {imagePath && (
                          <img
                            src={imagePath}
                            alt="hostImage"
                            draggable="false"
                            className="p-3 dialogueImageVideoShow"
                            width={100}
                          />
                        )}

                        {error.image && (
                          <div class="pl-1 text-left">
                            <Typography
                              variant="caption"
                              color="error"
                              style={{ fontFamily: "Circular-Loom" }}
                            >
                              {error.image}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div>
                    <div className="form-group mb-0">
                      <p className="form-label fw-bold mt-3"> Host Image</p>
                    </div>

                    <div className="hostAlbum d-flex">
                      <ReactDropzone
                        onDrop={(acceptedFiles) => onPreviewDrop(acceptedFiles)}
                        accept="image/*"
                      >
                        {({ getRootProps, getInputProps }) => (
                          <section className="mx-2">
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div
                                style={{
                                  height: 130,
                                  width: 130,
                                  border: "2px dashed gray",
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <i
                                  className="fas fa-plus"
                                  style={{ paddingTop: 30, fontSize: 70 }}
                                ></i>
                              </div>
                            </div>
                          </section>
                        )}
                      </ReactDropzone>
                      <div
                        className="hostImagePre d-flex ms-5"
                        style={{ flexWrap: "wrap" }}
                      >
                        {album?.length > 0 &&
                          album?.map((file, index) => {
                            return file?.type?.split("image")[0] === "" ? (
                              <>
                                <img
                                  height="60px"
                                  width="60px"
                                  alt="app"
                                  src={file.preview}
                                  style={{
                                    boxShadow:
                                      "0 5px 15px 0 rgb(105 103 103 / 00%)",
                                    border: "2px solid #fff",
                                    borderRadius: 10,
                                    marginTop: 10,
                                    float: "left",
                                    objectFit: "contain",
                                    marginRight: 15,
                                  }}
                                  draggable="false"
                                />
                                <div
                                  class="img-container"
                                  style={{
                                    display: "inline",
                                    position: "relative",
                                    float: "left",
                                  }}
                                >
                                  <i
                                    class="fas fa-times-circle text-danger"
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "4px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => removeImage(file)}
                                  ></i>
                                </div>
                              </>
                            ) : (
                              <>
                                <img
                                  height="60px"
                                  width="60px"
                                  alt="app"
                                  src={file}
                                  style={{
                                    boxShadow:
                                      "0 5px 15px 0 rgb(105 103 103 / 00%)",
                                    border: "2px solid #fff",
                                    borderRadius: 10,
                                    marginTop: 10,
                                    float: "left",
                                    objectFit: "contain",
                                    marginRight: 15,
                                  }}
                                  draggable="false"
                                />
                                <div
                                  class="img-container"
                                  style={{
                                    display: "inline",
                                    position: "relative",
                                    float: "left",
                                  }}
                                >
                                  <i
                                    class="fas fa-times-circle text-danger"
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "4px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => removeImage(file)}
                                  ></i>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </div>
                    {error.album && (
                      <div class="pl-1 text-left">
                        <Typography
                          variant="caption"
                          color="error"
                          style={{ fontFamily: "Circular-Loom" }}
                        >
                          {error.album}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-5 float-right">
                <button
  type="button"
  className="btn btn-info px-3"
  onClick={handelSubmit}
>
  Insert
</button>
                  <button
                    type="button"
                    className="btn ml-2 btn-danger px-3"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { createHost })(HostDialogue);

{/* <div className="col-md-6 col-12">
                        <div>
                          <div className="form-group mb-0">
                            <p className="form-label fw-bold mt-3">Coin</p>
                          </div>
                          <input
                            type="number"
                            placeholder="Enter Coin"
                            className="form-control"
                            value={coin}
                            min="0"
                            onChange={(e) => {
                              setCoin(e.target.value);
                              if (e.target.value === "") {
                                setError({ ...error, coin: "Coin is required" });
                              } else {
                                setError({ ...error, coin: "" });
                              }
                            }}
                            onKeyPress={handleKeyPress}
                          />
                          {error.coin && (
                            <div className="pl-1 text-left">
                              <Typography variant="caption" color="error">
                                {error.coin}
                              </Typography>
                            </div>
                          )}
                        </div>
                      </div> */}
